import { getLink } from '../../../utils/utils';

import author from './author';

const cite1Text = (
  `PPA – Pura Por Analizo, la supera grado de kemia pureco`
)
const cite1 = (
  `<sup><acronym title="${cite1Text}"><a href="#cite_note1" id="cite_ref1">[1]</a></acronym></sup>`
)

const content = {
  esp: (
    `
			<div style="text-align: justify;">
				<p class="mb-3 text-lg-end">
					Al kelkaj grupoj de laboratoranimaloj<br/>
					oni aplikas la studatan faktoron<br/>
					en diversaj koncentraĵoj; <br/>
					poste dum 2 semajnoj registras mortojn <br/>
					de animaloj en ĉiu grupo. Kaj en fino, <br/>
					per iu ajn statistika metodo elkalkulas <br/>
					la dozon kaŭzantan la morton de 50% <br/>
					de animaloj eluzitaj en la eksperimento (DL<sub>50</sub>).
				</p>
				
				<p class="mb-3">
					Kaj mia damnita elprovo ĝis nun ne sukcesas!
				</p>
				<p class="mb-3">
					Nu kion oni ankoraŭ bezonas: mi ĉion aldonadis kiel decas, laŭ la tabelo, pohore, mezuretas, kalkuletas, la reakciilon PPA${cite1} akiris, 
					kvankam jen samkursanoj miaj kun la ordinaraj mastrumaĉas; sed ili ja sukcesas, kaj mi ne! Diablo ĉiujn tiujn esplorojn formanĝu! 
					La diskongruo de rezultoj terura: DL<sub>50</sub> de 74 ĝis 622! 
					Nu, la reakciiloj ĉe mi senriproĉaj; do, la «musetoj» kulpas? – ankaŭ ne, de la sama raso kaj linio kiel ĉe aliuj, 
					la pura laboratoria linio U-85-216, ni ĉiuj ĝin prenis. 
					Sed ili jam finkalkulis kaj diplomlaborojn preskaŭ finis, kaj mi ĝis nun klopodaĉas ne povante kompreni, ĉu miaj substancoj estas venenaj aŭ ne. 
					Jen mortadas de ili «musetoj», jen ne… 
					Diable! 
					Kaj la profesoro, manĝu lin lupoj, ne volas helpi. 
					«Studu la metodaron de eksperimentoj, – diras li, –  Akumulu propran sperton!». 
					Akumulus mi por li sitelon da fekaĵoj! 
					Por kia kaco mi bezonas tian metodaron de eksperimentoj, se jam pretas por mi la loko en prestiĝa firmao, kaj tiam… 
					vi, oldulaĉo, daŭre perfortu la mensojn de studentoj, kaj mi 😀 prefere laborantasistinojn… 
					Ho, interalie, delonge mi jam knabinojn ne vidis… 
					«Li enprofundiĝis en sciencon!»… 
					Fek’, veturu jam ĉio al infero! 
				</p>
				<p class="mb-3">
					Kaj li rezolute elŝutis sur la medion numero 4 (kun maksimuma koncentriteco) la dekoblan dozon de la reakciilo. 
					Poste la respektivajn dozojn aldonis al aliaj medioj, notis ĉion en laboratoria ĵurnalo. 
					Ekridis: «Nu tiam certe ili mortaĉos jam. Ne plu havos mi diskongruon de rezultoj!»; kaj trankvile survojis hejmen.
				</p>

				
				<p class="bold text-center mb-3 mt-3">* * *</p>
				
				
				<p class="mb-3">
					Kaj vere, ĉiuj testataj animaloj (breditaj en vivario, kiu nomiĝis «planedo Tero») bonrezulte formortis. 
					Dank’ al tio estis indikitaj DL<sub>50</sub> por kelkaj novaj eventuale valoraj kemiaĵoj. 
					Mi legis, ke dum nur unu jaro en unu el la landoj de nia granda mondo estis eluzitaj en toksikologiaj esploroj 1 300 155 poreksperimentaj animaloj, 
					kaj en la tuta mondo da ili estas proksimume 30 milionoj. 
					Sed kion fari – endas! 
					Ja sen eksperimentoj sur bestoj ni ne povos defendi nin mem, la superajn estaĵojn, la kronon de evoluo. 
				</p>
				<p class="mb-3">
					Interalie, tiu stultulo tamen ne defendis sian diplomon. 
					La medio 4 (dekstraborda Ukrainio, rivero Dnestro kaj urbo Odessa ĉe la delto) estas plene ekstermita de li; 
					sed mi havis tie miajn proprajn interesojn. 
					Mi fondis tie kelkajn esplorojn, sed nun ĉiuj fruktoj de ili neniigitaj de tiu kreteno! 
					Scienco apartenas al ĉiuj, kaj neniu rajtas akapari iujn terenojn de ĝi! 
					Eĉ liaj gepatroj ne helpis. 
					Li ne sukcesis diplomiĝi en universitato, kaj mi… 
					Nu kio pri mi, mi daŭrigas esplorojn sur aliaj analogaj medioj. 
					Feliĉe, sur la «planedo Tero» dume sufiĉas loĝantaro por niaj eksperimentoj.
				</p>
			</div>
    `
  )
}

const itemName = {
  esp: 'Kion povas kaj kion ne povas metodoj in vitro'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
  }
}

export default item; 